import { Info } from 'lucide-react';

interface Props {
    text: string;
}

// Lightweight Tailwind-only info tooltip (no MUI, no extra dependency): a small
// info icon that reveals a short explanation on hover/focus, for use next to a
// form field label. Grayscale per the design system — tenant primary stays the
// only accent. CSS-only show/hide via the parent `group` + opacity transition.
const InfoTooltip = ({ text }: Props) => (
    <span className={'group relative inline-flex align-middle'}>
        <button
            type={'button'}
            aria-label={text}
            className={'text-foreground/40 hover:text-foreground/70 focus:outline-none'}
        >
            <Info className={'h-3.5 w-3.5'} />
        </button>
        <span
            role={'tooltip'}
            className={
                'pointer-events-none absolute left-0 top-full z-50 mt-1 w-60 rounded-md ' +
                'bg-foreground px-3 py-2 text-xs font-normal leading-snug ' +
                'text-text-contrast opacity-0 shadow-lg transition-opacity duration-150 ' +
                'group-hover:opacity-100 group-focus-within:opacity-100'
            }
        >
            {text}
        </span>
    </span>
);

export default InfoTooltip;
